import httpClient from '@/http-client'

const normalizeError = error => {
  return error.response && error.response.data
    ? error.response.data
    : { message: error.message || 'Network error. Please try again.' }
}

export const get = (options = {}) => {
  return httpClient
    .get('/api/assign-drivers', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(normalizeError(error)))
}

export const store = data => {
  return httpClient
    .post('/api/assign-drivers', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(normalizeError(error)))
}

export const searchBooking = (options = {}) => {
  return httpClient
    .get('/api/assign-drivers/search-booking', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(normalizeError(error)))
}

export const formModel = (options = {}) => {
  return httpClient
    .get('/api/assign-drivers/form-view-models', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(normalizeError(error)))
}

export const toPdf = voucherNo => {
  return httpClient
    .get(`/api/assign-drivers/${voucherNo}/pdf`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(normalizeError(error)))
}

export default { get, store, searchBooking, formModel, toPdf }